import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {NgFor, NgIf, NgStyle} from '@angular/common';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../service/auth.service';
import {NgbModal, NgbModalConfig, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerComponent, NgxSpinnerService} from 'ngx-spinner';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Subject} from 'rxjs';
import {SharedModule} from '../../../../shared/shared.module';
import {ParametreService} from '../../../parametre/parametre.service';
import {StructureService} from '../../../structure/services/structure.service';
import {ToasterService} from '../../../../globalServices/toaster.service';
import {AuthResponse, Logger} from '../../auth.model';
import {GeneralResponse} from '../../../parametre/parametre.model';
import {YoutubePlaylistService, YoutubeVideo} from './youtube-playlist.service';
import {RemoteConfigService} from './remote-config.service';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-login',
  standalone: true,
    imports: [
        SharedModule,
        RouterLink,
        NgStyle,
        NgxSpinnerComponent,
        NgIf,
        NgFor,
    ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  public show = false;
  public loginForm: UntypedFormGroup;
  private isloading = false;
  private modalReference: NgbModalRef;
  messageOperation: string;

  resetForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });
  validationForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  isProcessing = false;
  isCompleted = false;
  hasError = false;

  isSubmitting = false;
  resetEmailSent = false;

  playlistActive = false;
  playlistTitle = '';
  videos: YoutubeVideo[] = [];
  selectedVideo: YoutubeVideo | null = null;
  selectedVideoUrl: SafeResourceUrl | null = null;



  constructor(
      private spinner: NgxSpinnerService,
      private authService: AuthService,
      private parametreService: ParametreService,
      private fb: UntypedFormBuilder,
      config: NgbModalConfig,
      private modalService: NgbModal,
      private router: Router,
      private strutureService: StructureService,
      private activeroute: ActivatedRoute,
      private toastr: ToasterService,
      private youtubeService: YoutubePlaylistService,
      private remoteConfig: RemoteConfigService,
      private sanitizer: DomSanitizer,
  ) {
    this.loginForm = fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.remoteConfig.getBoolean('ft_externe_login_playlist_active').subscribe(active => {
      if (!active) return;
      this.youtubeService.getPlaylist().subscribe({
        next: ({ title, videos }) => {
          this.playlistTitle  = title;
          this.videos         = videos;
          this.playlistActive = videos.length > 0;
        },
        error: () => { this.videos = []; this.playlistActive = false; }
      });
    });
  }

  openVideoModal(video: YoutubeVideo, content: any): void {
    this.selectedVideo = video;
    this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/${video.videoId}?autoplay=1`
    );
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'video-modal' });
  }
  onSubmit(): void {
    //console.log(' send login data');
    try {
      var loggedIn$ = new Subject<boolean>();

      this.spinner.show().then(r => r);


      const loggerObject = new Logger( this.loginForm.value.email, this.loginForm.value.password);

      this.authService.login(loggerObject)   .subscribe(
          {
            next: (data) => {
              let responseGeneral = new AuthResponse();
              responseGeneral = data;
              //  //console.log('data', this.loginForm.value);
               console.log('response user data', responseGeneral);
              if (responseGeneral.success === true){
                this.authService.loggedUser = responseGeneral.user;
                // this.parametreService.initAllParams();
                //console.log('response user data', this.authService.loggedUser);
                if (this.authService.loggedUser==undefined){
                  this.toastr.error("Nom d'utilisateur ou mot de passe incorrect. Vérifiez votre saisie et essayez à nouveau", "Opération échouée");
                  this.spinner.hide().then(r => r);
                  this.router.navigate(['/auth/login']);
                  loggedIn$.next(false);

                  // this.router.navigate(['/error-403'],{ queryParams: {email: this.loggedUser.email}});
                  // resolve(false);
                  return false;// Authentication failed

                }else {
                  if ( this.authService.loggedUser.email_verified_at==null){
                    this.toastr.error("Votre compte n'est pas vérifié. Vérifiez vos e-mails pour le valider ou renvoyez l'email de vérification.", "Opération échouée");
                    this.router.navigate(['/auth/login']);
                    // loggedIn$.next(false);
                    this.spinner.hide().then(r => r);


                    // this.router.navigate(['/error-403'],{ queryParams: {email: this.loggedUser.email}});
                    // resolve(false); // Authentication failed
                    return false;// Authentication failed


                  }
                  else {
                    this.authService.getUserDataFile(this.authService.loggedUser);

                    this.authService.saveToken(responseGeneral.authorisation.token);

                    loggedIn$.next(true);
                    //console.log('user token', this.authService.getToken());
                    let niveau =this.authService.loggedUser.role.niveau;
                    // this.parametreService.initStructureParams();
                    this.spinner.hide().then(r => r);


                    if (niveau==2) {
                      console.log("/structure ");

                      // this.strutureService.getStructureDataByUser(this.authService.loggedUser.id);
                      this.router.navigate(['/structure']);
                      // return false;
                    } if (niveau>=3) {
                      console.log("/admin/accueil ");

                      this.router.navigate(['/admin/accueil']);
                      // return false;
                    } else {
                      // this.serviceCandidat.getCandidatForInfoByUser(this.authService.loggedUser.id);
                      console.log("/candidat ");

                      this.router.navigate(['/candidat']);
                      // return false;
                    }
                  }
                }


              }else {
                this.toastr.error(responseGeneral.message, "Opération échouée");
                this.spinner.hide().then(r => r);

                loggedIn$.next(false);

              }
            },
            error: error => {
              let erreurGeneral = new GeneralResponse();
              erreurGeneral = error;
              this.spinner.hide().then(r => r);
              this.toastr.error(erreurGeneral.message, "Opération échouée");

              loggedIn$.next(false);
            }
          }
      );
          // .subscribe(
          //     data => {
          //       //console.log("user logged",this.authService.loggedUser);
          //       //console.log("user logged data  has error",data);
          //
          //       if (!data){
          //
          //         //console.log("user logged has error",this.authService.loggedUser);
          //
          //         this.spinner.hide().then(r => r);
          //       }else {
          //         //console.log("user logged no error",this.authService.loggedUser);
          //
          //         if (this.authService.loggedUser==undefined){
          //           this.toastr.error("Erreur lors de la connexion", "Opération échouée");
          //           this.spinner.hide().then(r => r);
          //
          //         }else {
          //
          //           if (this.authService.loggedUser.email_verified_at==null){
          //             this.toastr.error("Veuillez vérifier votre compte en suivant le lien de confirmation envoyé à votre adresse électronique. ", "Opération échouée");
          //             this.spinner.hide().then(r => r);
          //
          //           }else {
          //             this.parametreService.initAllParams(this.authService.getHeaders());
          //
          //           }
          //
          //
          //           // this.navigation();
          //           this.spinner.hide().then(r => r);
          //
          //
          //           // this.openModal();
          //         }
          //       }
          //
          //       this.spinner.hide().then(r => r);
          //
          //     },
          //     error => {
          //
          //       let erreurGeneral = new GeneralResponse();
          //       erreurGeneral = error;
          //       // //console.log('oops', erreurGeneral);
          //
          //       this.spinner.hide().then(r => r);
          //       // this.openModal();
          //       this.toastr.error("Une erreur s'est produite lors de l' operation. Veuillez réessayer.", "Opération échouée");
          //
          //
          //     }
          // );
    }catch (e){
      this.spinner.hide().then(r => r);

    }



  }

  onResetRequest() {
    if (this.resetForm.invalid) return;

    this.isSubmitting = true;
    var data={

      "email": this.resetForm.value.email

    };

    this.authService.requestPasswordReset(data)
        .subscribe({
          next: data => {
            this.isSubmitting = false;
            let responseGeneral = new AuthResponse();
            responseGeneral = data;
            //  //console.log('data', this.loginForm.value);
            //  //console.log('response user data', responseGeneral);
            if (responseGeneral.success === true){
              this.resetEmailSent = true;

              this.messageOperation=responseGeneral.message;

              this.toastr.success(responseGeneral.message, "Opération réussie");


            }else {
              this.resetEmailSent = false;

              this.messageOperation=responseGeneral.message;

              this.toastr.error(responseGeneral.message, "Opération échouée");


            }
          },
          error: error => {
            this.isSubmitting = false;
            let erreurGeneral = new GeneralResponse();
            erreurGeneral = error;
            this.spinner.hide().then(r => r);
            this.messageOperation=erreurGeneral.message;

            this.toastr.error(erreurGeneral.message, "Opération échouée");
            // Handle error (show error message)
          }
        });
  }



  resendValidationEmail() {
    if (this.validationForm.invalid) return;
    var data={

      "email": this.validationForm.value.email

    };
    this.isProcessing = true;
    this.hasError = false;

    this.authService.resendEmailVerification(data)
        .subscribe({
          next: data => {
            this.isProcessing = false;
            let responseGeneral = new AuthResponse();
            responseGeneral = data;
            //  //console.log('data', this.loginForm.value);
            //  //console.log('response user data', responseGeneral);
            if (responseGeneral.success === true){

              this.isCompleted = true;

              this.toastr.success(responseGeneral.message, "Opération réussie");


            }else {
              this.hasError = true;
              this.toastr.error(responseGeneral.message, "Opération échouée");


            }
          },
          error: error => {
            this.isProcessing = false;
            this.hasError = true;
            let erreurGeneral = new GeneralResponse();
            erreurGeneral = error;
            this.spinner.hide().then(r => r);
            this.toastr.error(erreurGeneral.message, "Opération échouée");
            // Handle error (show error message)
            console.error('Erreur renvoi email:', error);
          }
        });
  }

  // tslint:disable-next-line:typedef
  // openModal() {
  //   const modalRef = this.modalService.open(NgbdModalContent);
  //   modalRef.componentInstance.name = 'World';
  // }
  // tslint:disable-next-line:typedef
  showPassword() {
    this.show = !this.show;
  }

    resendVerificationEmail() {

    }

  openModal(content) {
    this.resetForm.reset();
    this.validationForm.reset();
    this.modalReference = this.modalService.open(content, { size: 'lg' });

    // this.modalService.open(content, { size: 'lg' });
  }
}
